import styled, { css } from 'styled-components'

export const FromSelectStyled = styled.select`
  display: block;
  padding: 15px 35px 15px 15px;
  border: 2px solid ${({ theme, green }) => green ? theme.grassyGreen50 : theme.veryLightPink};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  color: ${({ theme }) => theme.greyishBrown};
  border-radius: 6px;
  transition: border .15s;
  width: 100%;
  -webkit-appearance: none;
  background: none;
  ::placeholder {
    color: ${({ theme }) => theme.lightPeach};
  }
`

export const FromSelectWrapper = styled.div`
  position: relative;
  &:before {
    content: '';
    width: 10px;
    height: 10px;
    position: absolute;
    top: 18px;
    right: 15px;
    border-right: 1.5px solid ${({ theme }) => theme.brownGrey};
    border-bottom: 1.5px solid ${({ theme }) => theme.brownGrey};
    transform: rotate(45deg);
  }
  ${({ error }) =>
    error &&
    css`
      ${FromSelectStyled} {
        border: 2px solid ${({ theme }) => theme.pastelRed};
      }
    `
  }
`